import { Helmet } from "react-helmet-async";

import { styled } from "@mui/material/styles";
import {
  Container,
  Typography,
  Divider,
} from "@mui/material";

import useResponsive from "../hooks/useResponsive";

import Logo from "../components/logo";

import { LoginForm } from "../sections/auth/login";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const StyledRoot = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const StyledSection = styled("div")(({ theme }) => ({
  width: "50%",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

export default function LoginPage() {
  const mdUp = useResponsive("up", "md");



  return (
    <>
      <Helmet>
        <title> Login | Digihelp </title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: "fixed",
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Se connecter
            </Typography>
            <Divider sx={{ mb: 5 }} />
            <LoginForm />
          </StyledContent>
        </Container>
        {mdUp && (
          <StyledSection>
            <img src="/assets/homeDigihelp.png" alt="login" />
          </StyledSection>
        )}
      </StyledRoot>
    </>
  );
}
